module.exports = __webpack_public_path__ + "static/team-management-af6043c0dc78c8a845ab8825855ca9cb.png";